import { Component, OnInit } from '@angular/core';

import { ReporteDinamicoService } from '../reporte-dinamico.service';
import { LoginService } from '../../../login/login.service';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { PeriodoEjercicioService } from '../../../control/periodo.service';
import { CatalogoCtbCtaComponent } from '../../../catalogo/ctb-cta/catalogo-ctb-cta/catalogo-ctb-cta.component';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ctb-estado-resultados-din',
  templateUrl: './ctb-estado-resultados-din.component.html',
  styleUrls: ['./ctb-estado-resultados-din.component.css'],
  providers: [ReporteDinamicoService]
})
export class CtbEstadoResultadosDinComponent implements OnInit {

  public busqueda: any = {
    _gral_emp_id: 0,
    _year: 0,
    _month: 0
  };
  private empresa_info_actual: any;
  public fechaReporte = new Date();
  public ejercicios: any[] = [];
  public reporteData: any = { ingresos: [], costos: [], gastos: [], resultado_integral_financiamiento: [], utilidad: [] };

  constructor(private reporteDinamicoService: ReporteDinamicoService, private loginService: LoginService, private modalService: NgbModal, private PeriodoEjercicioService: PeriodoEjercicioService) { }

  ngOnInit(): void {

    this.empresa_info_actual = this.loginService.empresa_info_actual;
    this.ejercicios = this.loginService.ejercicios;
    this.busqueda._gral_emp_id = this.loginService.empresa;

    this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.busqueda._year = ejercicio ? ejercicio : 0;

    });
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.busqueda._month = periodo ? periodo : 13;
      });

    



    this.cargarReporte();
  }


  cargarReporte() {
    console.log('Cargando reporte para:', this.busqueda);
    // Lógica para cargar el reporte basado en this.busqueda
    this.reporteDinamicoService.ctb_reporte_estado_resultados_din(this.busqueda._year, this.busqueda._month, this.busqueda._gral_emp_id).
      subscribe(data => {
        console.log('Datos del reporte:', data);
        this.reporteData = data.data;
      });

  }
  exportAsXLSX() {
    console.log('Exportando como XLSX para:', this.busqueda);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const datosCompletos: any[][] = [];

    // AGREGAR INFORMACIÓN SUPERIOR (TÍTULO Y DATOS DE EMPRESA) PRIMERO
    const info = [
      ['ESTADO DE RESULTADOS A ' + this.busqueda._year + ' - ' + this.busqueda._month],
      ['Empresa:', this.empresa_info_actual.titulo],
      ['RFC:', this.empresa_info_actual.rfc],
      ['Fecha:', this.fechaReporte.toLocaleDateString()],
      [], // Fila vacía para separar
      []  // Otra fila vacía
    ];

    // Agregar la información al inicio de datosCompletos
    datosCompletos.push(...info);

    // Función para agregar una sección DESPUÉS de la información
    const agregarSeccion = (nombreSeccion: string, datos: any[]) => {
      // Título de la sección
      datosCompletos.push([nombreSeccion]);
      datosCompletos.push([]); // Fila vacía

      // Encabezados
      datosCompletos.push(['Cuenta', 'Nombre', 'Saldo Inicial', 'Movimientos', 'Saldo Final']);

      // Datos
      datos.forEach(group => {
        const indentacion = '  '.repeat(group.bg_nivel || 0);
        datosCompletos.push([
          indentacion + group.bg_cuenta,
          indentacion + group.bg_nombre,
          group.bg_saldo_ini || 0,
          group.bg_mov_mens || 0,
          group.bg_saldo_fin || 0
        ]);
      });




      datosCompletos.push([]); // Fila vacía
      datosCompletos.push([]); // Otra fila vacía
    };
    const agregarUtilidad = (nombreSeccion: string, datos: any[]) => {
      // Título de la sección
      datosCompletos.push([nombreSeccion]);
      datosCompletos.push([]); // Fila vacía

      // Encabezados
      datosCompletos.push(['', '', 'Saldo Inicial', 'Movimientos', 'Saldo Final']);

      // Datos
      datos.forEach(group => {

        datosCompletos.push([
          '',
          nombreSeccion,
          group.mm_saldo_ini || 0,
          group.mm_mov_mens || 0,
          group.mm_saldo_fin || 0
        ]);
      });




      datosCompletos.push([]); // Fila vacía
      datosCompletos.push([]); // Otra fila vacía
    };
    // Agregar todas las secciones DESPUÉS de la información
    if (this.reporteData.ingresos && this.reporteData.ingresos.length > 0) {
      agregarSeccion('INGRESOS', this.reporteData.ingresos);
    }

    if (this.reporteData.costos && this.reporteData.costos.length > 0) {
      agregarSeccion('COSTOS', this.reporteData.costos);
    }

    if (this.reporteData.gastos && this.reporteData.gastos.length > 0) {
      agregarSeccion('GASTOS', this.reporteData.gastos);
    }

    if (this.reporteData.resultado_integral_financiamiento &&
      this.reporteData.resultado_integral_financiamiento.length > 0) {
      agregarSeccion('RESULTADO INTEGRAL DE FINANCIAMIENTO',
        this.reporteData.resultado_integral_financiamiento);
    }

    if (this.reporteData.utilidad && this.reporteData.utilidad.length > 0 && this.reporteData.utilidad[0].mm_mov_mens >= 0) {
      agregarUtilidad('UTILIDAD',
        this.reporteData.utilidad);
    }
    if (this.reporteData.utilidad && this.reporteData.utilidad.length > 0 && this.reporteData.utilidad[0].mm_mov_mens < 0) {
      agregarUtilidad('PERDIDA',
        this.reporteData.utilidad);
    }

    // Crear hoja con TODOS los datos (información + secciones)
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(datosCompletos);

    // Ajustar anchos de columnas
    const wscols = [
      { wch: 25 },
      { wch: 50 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 }
    ];
    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, 'Estado Resultados');

    const fechaStr = new Date().toISOString().split('T')[0];
    XLSX.writeFile(wb, this.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + `_estado_resultados_${fechaStr}.xlsx`);
  }

  exportAsPDF() {
    const doc = new jsPDF('portrait', 'mm', 'letter');
    const fecha = new Date();
    let startY = 20;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 15;

    // TÍTULO PRINCIPAL - PRIMERO
    doc.setFontSize(18);
    doc.setTextColor(0, 0, 0);
    doc.text('ESTADO DE RESULTADOS', pageWidth / 2, startY, { align: 'center' });
    startY += 10;

    // Período
    doc.setFontSize(12);
    doc.text(`Período: ${this.busqueda._year} - ${this.busqueda._month}`, pageWidth / 2, startY, { align: 'center' });
    startY += 8;

    // Información de la empresa
    doc.setFontSize(10);
    doc.text(`Empresa: ${this.empresa_info_actual.titulo || ''}`, margin, startY);
    startY += 6;

    doc.text(`RFC: ${this.empresa_info_actual.rfc || ''}`, margin, startY);
    startY += 6;

    doc.text(`Fecha: ${this.fechaReporte.toLocaleDateString()}`, margin, startY);
    startY += 6;

    doc.text(`Generado: ${fecha.toLocaleString()}`, margin, startY);
    startY += 15;

    // Línea separadora
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.5);
    doc.line(margin, startY - 5, pageWidth - margin, startY - 5);

    // Función para agregar una sección DESPUÉS del título
    const agregarSeccionPDF = (titulo: string, datos: any[], color: number[]) => {
      // Verificar si necesitamos nueva página
      if (startY > 240) {
        doc.addPage();
        startY = 20;
      }

      // Título de la sección
      doc.setFillColor(color[0], color[1], color[2]);
      doc.rect(margin, startY, pageWidth - 2 * margin, 8, 'F');

      doc.setFontSize(12);
      doc.setTextColor(255, 255, 255);
      doc.text(titulo, margin + 5, startY + 5.5);

      startY += 12;

      // Preparar datos
      const datosTabla = datos.map(group => {
        const indentacion = '  '.repeat(group.bg_nivel || 0);
        return [
          indentacion + group.bg_cuenta,
          indentacion + group.bg_nombre,
          this.formatCurrency(group.bg_saldo_ini),
          this.formatCurrency(group.bg_mov_mens),
          this.formatCurrency(group.bg_saldo_fin)
        ];
      });

      // Crear tabla
      autoTable(doc, {
        head: [['Cuenta', 'Nombre', 'Saldo Inicial', 'Movimientos', 'Saldo Final']],
        body: datosTabla,
        startY: startY,
        margin: { left: margin, right: margin },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 3,
          overflow: 'linebreak'
        },
        headStyles: {
          fillColor: [240, 240, 240],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          fontSize: 9,
          halign: 'center'
        },
        columnStyles: {
          0: { cellWidth: 25 },
          1: { cellWidth: 70 },
          2: { cellWidth: 25, halign: 'right' },
          3: { cellWidth: 25, halign: 'right' },
          4: { cellWidth: 25, halign: 'right' }
        },
        didDrawPage: (data) => {
          startY = data.cursor.y + 10;
        }
      });

      startY += 5;
    };



    // Función para agregar una sección DESPUÉS del título
    const agregarSeccionUtilidadPDF = (titulo: string, datos: any[], color: number[]) => {
      // Verificar si necesitamos nueva página
      if (startY > 240) {
        doc.addPage();
        startY = 20;
      }

      // Título de la sección
      doc.setFillColor(color[0], color[1], color[2]);
      doc.rect(margin, startY, pageWidth - 2 * margin, 8, 'F');

      doc.setFontSize(12);
      doc.setTextColor(255, 255, 255);
      doc.text(titulo, margin + 5, startY + 5.5);

      startY += 12;

      // Preparar datos
      const datosTabla = datos.map(group => {

        return [
          '' + titulo,
          this.formatCurrency(group.mm_saldo_ini),
          this.formatCurrency(group.mm_mov_mens),
          this.formatCurrency(group.mm_saldo_fin)
        ];
      });

      // Crear tabla
      autoTable(doc, {
        head: [['', 'Saldo Inicial', 'Movimientos', 'Saldo Final']],
        body: datosTabla,
        startY: startY,
        margin: { left: margin, right: margin },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 3,
          overflow: 'linebreak'
        },
        headStyles: {
          fillColor: [240, 240, 240],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          fontSize: 9,
          halign: 'center'
        },
        columnStyles: {
          0: { cellWidth: 42.5 },
          1: { cellWidth: 42.5, halign: 'right' },
          2: { cellWidth: 42.5, halign: 'right' },
          3: { cellWidth: 42.5, halign: 'right' }
        },
        didDrawPage: (data) => {
          startY = data.cursor.y + 10;
        }
      });

      startY += 5;
    };

    // Agregar secciones DESPUÉS del título
    if (this.reporteData.ingresos && this.reporteData.ingresos.length > 0) {
      agregarSeccionPDF('INGRESOS', this.reporteData.ingresos, [0, 123, 255]);
    }

    if (this.reporteData.costos && this.reporteData.costos.length > 0) {
      agregarSeccionPDF('COSTOS', this.reporteData.costos, [23, 162, 184]);
    }

    if (this.reporteData.gastos && this.reporteData.gastos.length > 0) {
      agregarSeccionPDF('GASTOS', this.reporteData.gastos, [255, 193, 7]);
    }

    if (this.reporteData.resultado_integral_financiamiento &&
      this.reporteData.resultado_integral_financiamiento.length > 0) {
      agregarSeccionPDF('RESULTADO INTEGRAL DE FINANCIAMIENTO',
        this.reporteData.resultado_integral_financiamiento,
        [220, 53, 69]);
    }
    if (this.reporteData.utilidad && this.reporteData.utilidad.length > 0 && this.reporteData.utilidad[0].mm_mov_mens >= 0) {
      agregarSeccionUtilidadPDF('UTILIDAD',
        this.reporteData.utilidad,
        [40, 167, 69]);
    }
    if (this.reporteData.utilidad && this.reporteData.utilidad.length > 0 && this.reporteData.utilidad[0].mm_mov_mens < 0) {
      agregarSeccionUtilidadPDF('PERDIDA',
        this.reporteData.utilidad,
        [231, 76, 60]);
    }

    // Pie de página
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(
        `Página ${i} de ${pageCount}`,
        pageWidth / 2,
        doc.internal.pageSize.height - 10,
        { align: 'center' }
      );
    }

    // Guardar PDF
    const fechaStr = fecha.toISOString().split('T')[0];
    const nombrePDF = this.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + `_estado_resultados_${this.busqueda._year}_${this.busqueda._month}_${fechaStr}.pdf`;
    doc.save(nombrePDF);
  }


  formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2
    }).format(value);
  }



}
